var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, forwardRef, useEffect, } from "react";
import { useForm } from "react-hook-form";
import MaskedInput from "react-text-mask";
import SubscriberService from "../services/SubscriberService";
import { removeCharactersAndSpecialCharacter } from "../../App/utils/formatter";
import PhoneMaskInput from "../../App/components/PhoneInput";
import "../styles/SubscriberForm.css";
import "../../App/styles/GlobalStyle.css";
var SubscriberForm = function (props) {
    var _a = useState(props.subscriberData.document), document = _a[0], setDocument = _a[1];
    var _b = useState(props.subscriberData.phone), phoneNumber = _b[0], setPhoneNumber = _b[1];
    var _c = useState(), internetSpeed = _c[0], setInternetSpeed = _c[1];
    var _d = useState([]), internetSpeeds = _d[0], setInternetSpeeds = _d[1];
    var _e = useForm({ mode: "onChange" }), handleSubmit = _e.handleSubmit, register = _e.register, isSubmitting = _e.formState.isSubmitting, watch = _e.watch, reset = _e.reset;
    function onSubmit(subscriber) {
        var subscriberData = {
            id: subscriber.id,
            name: subscriber.name,
            email: subscriber.email,
            document: removeCharactersAndSpecialCharacter(document),
            phone: phoneNumber,
            internet_speed_id: internetSpeed === null || internetSpeed === void 0 ? void 0 : internetSpeed.id,
            customer_plan: subscriber.customer_plan,
        };
        props.callbackSubscriberData(subscriberData);
        props.callbackInternetSpeedData(internetSpeed);
    }
    useEffect(function () {
        reset({
            id: props.subscriberData.id,
            name: props.subscriberData.name,
            email: props.subscriberData.email,
            document: props.subscriberData.document,
            customer_plan: props.subscriberData.customer_plan,
            internet_speed_id: props.subscriberData.internet_speed_id,
        });
        setDocument(props.subscriberData.document);
        setPhoneNumber(props.subscriberData.phone);
        if (internetSpeeds.length > 0) {
            var speed = internetSpeeds.find(function (s) { return s.id === props.subscriberData.internet_speed_id; });
            setInternetSpeed(speed || undefined);
        }
    }, [props.subscriberData, reset, internetSpeeds]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var currentData = {
            id: props.subscriberData.id,
            name: (_b = (_a = watch("name")) !== null && _a !== void 0 ? _a : props.subscriberData.name) !== null && _b !== void 0 ? _b : "",
            email: (_d = (_c = watch("email")) !== null && _c !== void 0 ? _c : props.subscriberData.email) !== null && _d !== void 0 ? _d : "",
            document: (_e = document !== null && document !== void 0 ? document : props.subscriberData.document) !== null && _e !== void 0 ? _e : "",
            phone: (_f = phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : props.subscriberData.phone) !== null && _f !== void 0 ? _f : "",
            customer_plan: (_h = (_g = watch("customer_plan")) !== null && _g !== void 0 ? _g : props.subscriberData.customer_plan) !== null && _h !== void 0 ? _h : "",
            internet_speed_id: (internetSpeed === null || internetSpeed === void 0 ? void 0 : internetSpeed.id) || props.subscriberData.internet_speed_id,
        };
        if (props.callbackSubscriberDataUpdate) {
            props.callbackSubscriberDataUpdate(currentData);
        }
    }, [
        watch("name"),
        watch("email"),
        document,
        phoneNumber,
        watch("customer_plan"),
        internetSpeed === null || internetSpeed === void 0 ? void 0 : internetSpeed.id,
    ]);
    function changeInternetSpeed(event) {
        setInternetSpeed(internetSpeeds.find(function (internet_speed) {
            return internet_speed.id === parseInt(event.target.value);
        }));
    }
    function changeDocument(event) {
        setDocument(event.target.value);
    }
    function changephoneNumber(event) {
        setPhoneNumber(event.target.value);
    }
    function getInputMask() {
        return [
            /\d/,
            /\d/,
            /\d/,
            ".",
            /\d/,
            /\d/,
            /\d/,
            ".",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
        ];
    }
    useEffect(function () {
        function getInternetSpeeds() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriberService.getSubscriberSpeed().then(function (res) {
                                setInternetSpeeds(res.data.internet_speeds);
                                setInternetSpeed(res.data.internet_speeds.find(function (internet_speed) {
                                    return internet_speed.id === props.subscriberData.internet_speed_id;
                                }));
                            }, function (err) {
                                if (err.response.status === 403) {
                                }
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (internetSpeeds.length === 0) {
            getInternetSpeeds();
        }
    }, [internetSpeeds.length]);
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "container-subscriber-form" }, { children: [_jsx("div", __assign({ className: "d-flex justify-content-between align-items-center" }, { children: _jsx("h3", { children: "Dados" }) })), _jsx("hr", {}), _jsx("div", __assign({ className: "subscriber-form" }, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsx("input", __assign({}, register("id"), { type: "hidden", defaultValue: props.subscriberData.id })), _jsxs("div", { children: [_jsxs("label", __assign({ id: "name-label", htmlFor: "name", style: { marginTop: "0" } }, { children: ["Nome ", _jsx("span", __assign({ className: "text-danger" }, { children: "*" }))] })), _jsx("input", __assign({ type: "text" }, register("name"), { required: true, minLength: 3, id: "name", defaultValue: props.subscriberData.name, disabled: props.disabled }))] }), _jsxs("div", { children: [_jsxs("label", __assign({ id: "email-label", htmlFor: "email" }, { children: ["E-mail ", _jsx("span", __assign({ className: "text-danger" }, { children: "*" }))] })), _jsx("input", __assign({ type: "email" }, register("email"), { required: true, id: "email", defaultValue: props.subscriberData.email, disabled: props.disabled }))] }), _jsxs("div", { children: [_jsxs("label", __assign({ id: "document-label", htmlFor: "document" }, { children: ["CPF ", _jsx("span", __assign({ className: "text-danger" }, { children: "*" }))] })), _jsx(MaskedInput, __assign({}, register("document"), { name: "document", id: "document", mask: getInputMask, guide: false, onChange: changeDocument, value: document, max: 11, required: true, defaultValue: props.subscriberData.document, disabled: props.disabled }))] }), _jsx(PhoneMaskInput, { userphone: phoneNumber || '', onChange: changephoneNumber, className: "form-control", requiredLabel: true, disabled: props.disabled }), _jsxs("div", { children: [_jsxs("label", __assign({ htmlFor: "" }, { children: ["Velocidade de Internet ", _jsx("span", __assign({ className: "text-danger" }, { children: "*" }))] })), _jsxs("select", __assign({ required: true, value: internetSpeed === null || internetSpeed === void 0 ? void 0 : internetSpeed.id }, register("internet_speed_id"), { onChange: changeInternetSpeed, disabled: props.disabled }, { children: [_jsx("option", __assign({ value: "", hidden: true }, { children: "Selecione o plano" })), internetSpeeds.length > 0 ? (internetSpeeds.map(function (item, index) { return (_jsx("option", __assign({ value: item.id }, { children: item.speed }), index)); })) : (_jsx("option", __assign({ disabled: true }, { children: "Nenhuma velocidade cadastrada" })))] }))] }), _jsxs("div", { children: [_jsx("label", __assign({ id: "plan-label", htmlFor: "customer_plan" }, { children: "Plano" })), _jsx("input", __assign({ type: "text" }, register("customer_plan"), { minLength: 3, id: "customer_plan", defaultValue: props.subscriberData.customer_plan, "aria-labelledby": "customer_plan-label", disabled: props.disabled }))] })] })) }))] })) }));
};
var CustomInput = forwardRef(function (_a, ref) {
    var onChange = _a.onChange, props = __rest(_a, ["onChange"]);
    return (_jsx("input", __assign({}, props, { required: true, ref: ref, onChange: onChange, type: "text", className: "form-control", id: "phone", "aria-labelledby": "phone-label" })));
});
export default SubscriberForm;
